import { WaiverConfiguration } from '../types/waiver';
import { get, post } from './commonFetch';

export function snoozeWaiverConfiguration(
  airlineCode: string,
  hours: number,
): Promise<any> {
  const url = `/api/waivers/configurations/${airlineCode}/snooze?hours=${hours}`;
  return post(url, {});
}

export function getAllWaiverConfigurations(): Promise<WaiverConfiguration[]> {
  return get('/api/waivers/configurations');
}
